"use strict";

exports.__esModule = true;
exports["default"] = Email;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Email(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M511.006 96.416l-255 191.5-255-191.5c0-8.662 3.145-16.152 9.444-22.459 6.29-6.298 13.77-9.457 22.431-9.457h446.25c8.652 0 16.132 3.159 22.43 9.457 6.291 6.307 9.445 13.797 9.445 22.459zm-510 57.332l255 191.5 255-191.5v261.836c0 8.672-3.154 16.162-9.444 22.459-6.298 6.308-13.779 9.457-22.43 9.457H32.881c-8.661 0-16.141-3.149-22.431-9.457-6.299-6.298-9.444-13.788-9.444-22.459V153.748z"
  }));
}